const actions = {
    GET_DATA: 'client/GET_DATA',
    SET_DATA: 'client/SET_DATA',

    SET_INITIAL_ATTRIBUTES: "addresses/SET_INITIAL_ATTRIBUTES"
};

export default actions;